import * as React from "react";
import cx from "classnames";
import { ButtonLink } from "components/Button/index";
import { WordScroller } from "components/WordScroller/index";
import style from "./Main.css";
import { ShapeGrey } from "components/Shape";
import hexahedron from "_images/hexahedron.svg";
import stack_top from "./icons/STACK_TOP.png";
import stack_middle from "./icons/STACK_MIDDLE.png";
import stack_bottom from "./icons/STACK_BOTTOM.png";

import { AnimationLogo } from "components/Logo";

const Stack = () => (
  <div className={style.stack}>
    <img src={stack_top} />
    <img src={stack_middle} />
    <img src={stack_bottom}/>
    <img src={stack_bottom}/>
  </div>
);

export const Main = ({ onScrollDown }) => (
  <section className={style.main}>
    <div className={style.bg} />
    <ShapeGrey className={style.shape1} animate="rotation fast" />
    <ShapeGrey className={style.shape2} animate="rotation slower" />
    <ShapeGrey className={style.shape3} animate="rotation fast" />
    <div className={style.content}>
      <div className={style.right}>
    <Stack/>
        <h2 className={cx(style.header, "wow", "fadeInUp")} data-wow-offset="0" style={{marginBottom: '0rem', fontSize: '4rem', marginTop: '10rem'}}>What we do</h2>
        <p
          className={cx(style.descLarge, "wow", "fadeInUp")}
          style={{marginTop: '0.5rem'}}
          data-wow-offset="0"
          data-wow-delay="0.25s">
          Engineering <span className={style.rotate}/>solutions for the digital age. 
        </p>
        <p
          className={cx(style.desc, "wow", "fadeInUp")}
          style={{marginTop: '0.5rem'}}
          data-wow-offset="0"
          data-wow-delay="0.25s">
          BlockScience ® is a complex systems engineering, R&D, and analytics firm. By integrating cutting-edge research, applied mathematics, and computational engineering, we analyze and design safe and resilient socio-technical systems for clients and partners spanning various sectors including for-profit, non-profit, academia, and government.
        </p>
        <h2 className={cx(style.header, "wow", "fadeInUp")} data-wow-offset="0" style={{marginBottom: '0rem', fontSize: '4rem'}}>How we do it</h2>
        <p
          className={cx(style.desc, "wow", "fadeInUp")}
          style={{marginTop: '0.5rem'}}
          data-wow-offset="0"
          data-wow-delay="0.25s"
        >
          Our R&D occurs in iterative cycles between open-source research and software development, and application of the research and tools to client projects. Our client work includes design and evaluation of economic and governance mechanisms based on research, simulation, and analysis. We also provide post-launch monitoring and maintenance via reporting, analytics, and decision support software. 
        </p>
        <ButtonLink
          to="/contact"
          className={cx(style.button, "wow", "fadeIn")}
          data-wow-delay="0.3s"
          data-wow-offset="0"
        >
          GET IN TOUCH
        </ButtonLink>
      </div>
    </div>
  </section>
);
